var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThickArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.761522 0.768845C1.77689 -0.256282 3.42311 -0.256282 4.43848 0.768845L12.2385 8.64384C13.2538 9.66897 13.2538 11.331 12.2385 12.3562L4.43848 20.2312C3.42311 21.2563 1.77689 21.2563 0.761522 20.2312C-0.253841 19.206 -0.253841 17.544 0.761522 16.5188L6.72304 10.5L0.761522 4.48116C-0.253841 3.45603 -0.253841 1.79397 0.761522 0.768845Z",
    fill: "#582483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickArrowRight);
export default __webpack_public_path__ + "static/media/thick-arrow-right.017ecc2cd52cd7a2d9deaae0373c3625.svg";
export { ForwardRef as ReactComponent };